import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { client } from 'rsui-core/lib/post-message';
import type { ElForm } from 'element-ui/types/form';
import cloneDeep from 'lodash/cloneDeep';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import CouponCard from './couponCard';
import areaList from './areaList';
import style from '@/views/components/productManager/style.vue';
import baseAPIService from '@/services/base/baseAPIService.ts';
import { noop } from '@/util';
import { IPSService } from '@/services/ipsServices';
import couponLink from '@/views/components/linkForm/coupon';
import { EmpServiceAPIActions } from '@/services/empService';

interface IpsCouponIfo {
  gsciId?: number;
  siteId?: number;
  cplId?: string;
  cplName?: string;
  cplType?: number;
  useBeginTime?: number;
  useEndTime?: number;
  receiptConfig?: receiptConfig;
  receiptLimit?: { type?: 0 | 1; maxNum?: number };
  tagConfig?: { tagName?: string; tagSort?: 0 | 1; isUseGuidTag?: number };
}

interface receiptConfig {
  isAllReceipt?: number;
  limitRegion?: { configInLalType?: 0 | 1; lalConfigInfo?: lalConfigItem[] };
  conditionType?: number;
  memberTagConfig?: string;
}

interface lalConfigItem {
  node?: string;
  latitude?: number;
  longitude?: number;
  maxKm?: number;
}

@DialogFactory
@Component({
  components: {
    CouponCard,
  },
  mixins: [style],
})
export default class AddCoupons extends IPSDialog {
  /**
   * 弹窗标题
   * @type {string}
   */
  title = '添加券';

  $refs: {
    form: ElForm;
  };

  /**
   * 优惠券Id
   * @type {number}
   */
  gsciId: number;

  sgId: number;

  siteCode = '';

  formData: IpsCouponIfo = {
    gsciId: 0,
    siteId: 0,
    cplId: '',
    cplName: '',
    cplType: 0,
    useBeginTime: 0,
    useEndTime: 0,
    receiptConfig: {
      isAllReceipt: 1,
      conditionType: 1,
      limitRegion: {
        configInLalType: 0,
        lalConfigInfo: [],
      },
      memberTagConfig: '',
    },
    receiptLimit: {
      type: 0,
      maxNum: 0,
    },
    tagConfig: {
      tagName: '',
      tagSort: 0,
      isUseGuidTag: 0,
    },
  };

  rules = {
    'receiptLimit.maxNum': [{ required: true, message: ' ', trigger: ['blur.change'] }],
    'cplId': [{ required: true, message: ' ', trigger: 'change' }],
  };

  condition: any = {
    id: '',
    text: '',
  };

  couponCardInfo: ItemObject = {};

  siteId = 0;

  domain = '';

  tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  @Watch('formData.receiptConfig.conditionType', { deep: true, immediate: true })
  watchCondition(n) {
    // if (n === 2) {
    //   this.formData.tagConfig = {
    //     tagName: "",
    //     tagSort: 0,
    //     isUseGuidTag: 0,
    //   };
    // }
  }

  mounted() {
    this.formData.siteId = this.siteId;
    this.formData.gsciId = this.gsciId;
    this.gsciId && this.getData();
    this.gsciId && (this.title = '编辑券');
    this.getDomain();
  }

  getDomain() {
    IPSService.getGroupInfo({ postParams: baseAPIService.resolveCorpId }).then((response) => {
      this.domain = response.crmUrl;
    });
  }

  /**
   * 获取数据
   * @returns null
   */
  getData(): void {
    IPSService.siteCouponInfo({
      postParams: {
        siteId: this.siteId,
        gsciId: this.gsciId,
      },
    }).then((response: any) => {
      response.tagConfig.isUseGuidTag = Number(!!((response.tagConfig.tagName && response.tagConfig.tagName.trim()) || response.tagConfig.tagSort));
      response.receiptConfig.conditionType = 1;
      response.receiptConfig.memberTagConfig && (response.receiptConfig.conditionType = 2);
      this.condition.id = response.receiptConfig.memberTagConfig;
      this.condition.id && this.getConditionText();
      this.formData = cloneDeep(response);
      this.getCrmCouponInfo(this.formData.cplId);
    });
  }

  // 获取条件
  getConditionText() {
    if (!this.condition.id) {
      return;
    }
    IPSService.customerCondition({
      queryParams: {
        id: this.condition.id,
        EXT_IPS__SITE: this.siteId,
      },
    }).then((response) => {
      let length = 0;
      (response.conditions || []).forEach((val) => {
        const orLength = val.or ? val.or.length : 0;
        const andLength = val.and ? val.and.length : 0;
        length = length + orLength + andLength;
      });
      this.condition.text = `已选择${length}个条件`;
    });
  }

  /**
   * 获取crm优惠券详情
   * @param cplId
   */
  getCrmCouponInfo(cplId: string) {
    IPSService.crmCouponIfo({
      postParams: {
        siteId: this.siteId,
        cplId,
      },
    }).then((response) => {
      this.couponCardInfo = Object.assign({}, { cplId, gsciId: this.gsciId }, response);
    });
  }

  /**
   * 选择优惠券
   * @returns null
   */
  chooseCoupons(): void {
    couponLink.open({ siteCodes: [this.siteCode], params: { isIps: 1, unlimited: true } }).then((result) => {
      this.formData.cplId = result.id;
      this.getCrmCouponInfo(result.id);
    }, noop);
  }

  /**
   * 选择区域
   * @returns null
   */
  selectArea(): void {
    areaList.open({ dataList: this.formData.receiptConfig.limitRegion.lalConfigInfo }).then((result) => {
      this.formData.receiptConfig.limitRegion.lalConfigInfo = result;
    }, noop);
  }

  /**
   * 根据筛选条件
   */
  setCondition(e) {
    e.stopPropagation();
    const protocol = `${location.protocol}//`;
    let hostName = location.hostname;
    hostName.includes('host') && (hostName = 'ips.maintenance.qingger.cn');

    IPSService.siteGroupConfig({
      postParams: {
        sgId: this.sgId,
        siteId: this.siteId,
      },
    }).then((res) => {
      client
        .pick({
          path: 'customer-predicate',
          dialogStyle: { width: '50vw', height: '100vh', backgroudColor: '#eee', zIndex: 99999999999 },
          modelDialog: true,
          slide: 'left',
          props: {
            params: { actId: res.actId || 2 },
            zIndex: 99999999999,
            id: this.condition.id,
            exclude: ['#root.crmPublicAccounts'],
          },
          domain: `${protocol + hostName}/scrm/web`,
          cancel: true,
          search: `?baseURL=/nips/scrm&ext_ips__auth_token=${this.tokenData.Authorization}&ext_ips__site=${this.siteId}`,
        })
        .then((r: any) => {
          this.condition = r;
          this.formData.receiptConfig.memberTagConfig = r.id;
        });
    });
  }

  beforeConfirm() {
    this.$refs.form.validate((result) => {
      if (result) {
        const postParams = cloneDeep(this.formData);
        !postParams.tagConfig.isUseGuidTag && ((postParams.tagConfig.tagName = ''), (postParams.tagConfig.tagSort = 0));
        postParams.receiptConfig.isAllReceipt === 0 && postParams.receiptConfig.conditionType === 1 && (postParams.receiptConfig.memberTagConfig = '');
        postParams.receiptConfig.isAllReceipt === 0 && postParams.receiptConfig.conditionType === 2 && ((postParams.receiptConfig.limitRegion.configInLalType = 0), (postParams.receiptConfig.limitRegion.lalConfigInfo = []));
        if (!postParams.receiptConfig.isAllReceipt) {
          if (postParams.receiptConfig.conditionType === 1 && !postParams.receiptConfig.limitRegion.lalConfigInfo.length) {
            this.$message.warning('请添加指定区域');
            this.confirmloading = false;
            return;
          }
          if (postParams.receiptConfig.conditionType === 2 && !postParams.receiptConfig.memberTagConfig) {
            this.$message.warning('请设定领取条件');
            this.confirmloading = false;
            return;
          }
        }
        if (!postParams.receiptConfig.isAllReceipt) {
          if (postParams.receiptConfig.conditionType === 1) {
            postParams.receiptConfig.memberTagConfig = '';
          }
          if (postParams.receiptConfig.conditionType === 2) {
            postParams.receiptConfig.limitRegion.lalConfigInfo = [];
          }
        }
        if (postParams.receiptConfig.isAllReceipt) {
          postParams.receiptConfig.limitRegion = {
            configInLalType: 0,
            lalConfigInfo: [],
          };
          postParams.receiptConfig.memberTagConfig = '';
        }
        if (!postParams.tagConfig.isUseGuidTag) {
          postParams.tagConfig = {
            tagName: '',
            tagSort: 0,
          };
        }
        IPSService.siteCouponAdd({
          postParams,
        }).then(
          (response) => {
            this.$emit('result', {});
            this.$emit('hidden');
          },
          () => {
            this.confirmloading = false;
          },
        );
      } else {
        this.confirmloading = false;
      }
    });
  }

  renderContent(h) {
    return (
      <el-form props={{ model: this.formData }} rules={this.rules} label-position="left" label-width="120px" ref="form" show-message={false} style="max-height: 450px" class="add-coupons-form">
        <el-form-item label="优惠券" prop="cplId">
          <el-button type="primary" onClick={this.chooseCoupons.bind(this)} disabled={!!this.couponCardInfo.cplId}>
            +&nbsp;&nbsp;添加券
          </el-button>
          {!!this.couponCardInfo.cplId && <CouponCard data={this.couponCardInfo} onRemove={() => (this.couponCardInfo = {})} />}
        </el-form-item>
        <el-form-item label="领取门槛" prop="">
          <el-radio-group class="r-mt-8" v-model={this.formData.receiptConfig.isAllReceipt}>
            <el-radio class="line-height-36" label={1}>
              所有会员均可领取&nbsp;&nbsp;
              <el-tooltip class="item" effect="light" content={'所有登录商城人员（含非会员）均可见该券并领取，非会员领取前需入会'} placement="top">
                <i class="iconfont iconzhushi1 font-size-14" />
              </el-tooltip>
            </el-radio>
            <br />
            <el-radio label={0} style="line-height: 24px">
              指定条件领取
            </el-radio>
          </el-radio-group>
          {this.formData.receiptConfig.isAllReceipt === 0 && (
            <div class="r-ml-24 line-height-2">
              <el-radio class="line-height-36" v-model={this.formData.receiptConfig.conditionType} label={1}>
                按会员登录所在地设定领取条件&nbsp;&nbsp;
                <el-tooltip class="item" effect="light" content={'可按（经纬度+周边距离）配置可领券或不可领券的区域，在小程序前端获取顾客经纬度后，判断该顾客是否可见及领取该券'} placement="top">
                  <i class="iconfont iconzhushi1 font-size-14" />
                </el-tooltip>
              </el-radio>
              {this.formData.receiptConfig.conditionType === 1 && (
                <div class="r-ml-24">
                  <span class="r-mr-8">以下区域</span>
                  <el-select class="wid-40" v-model={this.formData.receiptConfig.limitRegion.configInLalType}>
                    <el-option label="可" value={0} />
                    <el-option label="不可" value={1} />
                  </el-select>
                  <span class="r-ml-8 r-mr-16">领取</span>
                  <span class="scopeSpan" onClick={this.selectArea.bind(this)}>
                    编辑区域
                  </span>
                </div>
              )}
              {this.formData.receiptConfig.conditionType === 1 && (
                <div class="r-ml-24">
                  {this.formData.receiptConfig.limitRegion.lalConfigInfo.map((vl, vi) => {
                    return (
                      <el-tag class="tag r-py-8 r-pr-12" key={vi}>
                        {`${vl.node}周边${vl.maxKm}Km`}
                      </el-tag>
                    );
                  })}
                </div>
              )}
              <el-radio class="line-height-24 block r-mr-8" v-model={this.formData.receiptConfig.conditionType} label={2} style="width: fit-content">
                按会员属性/标签设定领取条件
                <el-tooltip class="item" effect="light" content={'可按照会员属性及标签配置领取该券的条件'} placement="top">
                  <i class="iconfont iconzhushi1 font-size-14" />
                </el-tooltip>
              </el-radio>
              {this.formData.receiptConfig.conditionType === 2 && (
                <div class="condition-selected" onClick={e => this.setCondition(e)}>
                  {!!this.condition.text && (
                    <el-tag class="tag" closable onClose={() => (this.condition = {})}>
                      {this.condition.text}
                    </el-tag>
                  )}
                  <i class="iconfont iconshaixuan1" />
                </div>
              )}
            </div>
          )}
        </el-form-item>
        <el-form-item label="领取限制" prop="receiptLimit.maxNum">
          <span>每个符合领取条件的会员&nbsp;&nbsp;</span>
          <el-select class="wid-40" v-model={this.formData.receiptLimit.type}>
            <el-option label="总共" value={0} />
            <el-option label="每天" value={1} />
          </el-select>
          <span class="r-ml-8 r-mr-8">可领</span>
          <el-input-number class="wid-40" v-model={this.formData.receiptLimit.maxNum} controls={false} precision={0} min={1} max={999999} />
          <span class="r-ml-8">张</span>
        </el-form-item>
        <el-form-item label="领券引导标签" prop="" class="guid-tag">
          <el-checkbox
            v-model={this.formData.tagConfig.isUseGuidTag}
            true-label={1}
            false-label={0}
            // disabled={this.formData.receiptConfig.isAllReceipt === 0 && this.formData.receiptConfig.conditionType === 2}
          >
            以标签形式在商品列表中展示，引导顾客点击
          </el-checkbox>
          {!!this.formData.tagConfig.isUseGuidTag
            && (this.formData.receiptConfig.isAllReceipt === 1
              || (this.formData.receiptConfig.isAllReceipt === 0 && this.formData.receiptConfig.conditionType === 1)
              || (this.formData.receiptConfig.isAllReceipt === 0 && this.formData.receiptConfig.conditionType === 2)) && [
            <div class="r-py-4">
              <el-input class="wid-100" v-model={this.formData.tagConfig.tagName} maxlength={10} show-word-limit />
                &nbsp;&nbsp;&nbsp;&nbsp;
              {!!(this.formData.tagConfig.tagName && this.formData.tagConfig.tagName.trim()) && <span class="r-px-8 bg-red inline-block text-white font-size-12 opacity-7 border-radius-4">{this.formData.tagConfig.tagName}</span>}
            </div>,
            <el-checkbox v-model={this.formData.tagConfig.tagSort} true-label={1} false-label={0}>
                此标签优先展示
            </el-checkbox>,
          ]}

          {this.formData.receiptConfig.isAllReceipt === 0 && this.formData.receiptConfig.conditionType === 1 && (
            <div class="tip text-deep-purple-15">
              <span class="redText">*&nbsp;</span>
              &nbsp;部分区域的会员可领取的券，如会员登录地的经纬度在所设定的区域范围内，则可在商品列表中看到该券的【领券引导标签】并领取。该标签只会展示一个，如勾选优先展示，则本标签将有更多展示机会。
            </div>
          )}
          {this.formData.receiptConfig.isAllReceipt === 0 && this.formData.receiptConfig.conditionType === 2 && (
            <div class="tip">
              <span class="redText" onClick={this.getConditionText.bind(this)}>
                *
              </span>
              &nbsp;指定会员属性/标签领券条件的券，如会员满足所设的会员/标签，则可在商品列表中看到该券的【领券引导标签】并领取。该标签只会展示一个，如勾选优先展示，则本标签将有更多展示机会。
            </div>
          )}
          {this.formData.receiptConfig.isAllReceipt === 1 && (
            <div class="tip">
              <span class="redText">*&nbsp;</span>
              &nbsp;所有会员均可领取的券，可在商品列表中展示该券的【领券引导标签】。该标签只会展示一个，如勾选优先展示，则本标签将有更多展示机会
            </div>
          )}
        </el-form-item>
      </el-form>
    );
  }
}
